// extracted by mini-css-extract-plugin
export default {"paymentSection":"B_-z","disabled":"C_-z"};